import { ScreenBreakpointSize } from './enums'

export const getScreenBreakpointSize = (screenSize: ScreenBreakpointSize, shift = 0): string => {
  return `${screenSize + shift}px`
}
